// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderStatusFormStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusForm";
import { xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

orderStatusFormStyles.form = {
    css: css`
        margin: 20px 0;
        display: flex;
        align-items: baseline;
        @media print {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            flex-flow: wrap;
        }
    `,
};

orderStatusFormStyles.submitButton = {
    css: css`
        margin-top: 22px;
        align-self: flex-start;
        min-height: 36px;
        @media screen and (max-width: 500px) {
            width: 100%;
            margin-top: 15px;
        }
    `,
};

orderStatusFormStyles.emailOrPostalCodeTextField = {
    cssOverrides: {
        formField: css`
            width: 185px;
            margin-right: 30px;

            @media screen and (max-width: 500px) {
                width: 100%;
                margin-right: 0;
            }
        `,
    },
};

orderStatusFormStyles.orderNumberTextField = {
    cssOverrides: {
        formField: css`
            width: 185px;
            margin-right: 30px;
            @media screen and (max-width: 500px) {
                width: 100%;
                margin-right: 0;
                margin-bottom: 12px;
            }
        `,
    },
};
